import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { getProductPricingStack } from 'features/product/pricing/actions';
import { setTopNavColorDark } from 'features/navigation/header/actions';

import Grid from '@material-ui/core/Grid';
import CallsToAction from 'components/CallsToAction';
import Container from 'components/Container';
import MetaTags from 'components/MetaTags';
import PaddedDivider from 'components/PaddedDivider';
import { PageHeaderText } from 'components/PageHeader';
import Quote from 'components/Quote';
import { RelatedContent } from 'components/RelatedContent';
import styled from 'styled-components';
import { lightTheme, darkTheme, palette } from 'theme';
import ExtendedFooter from 'views/Layout/Elements/ExtendedFooter';
import WideProductCard from './elements/WideProductCard';

const Wrapper = styled.div`
  background-color: ${palette.grey[50]};
  margin-top: -64px;
  padding-top: 64px;
  padding-bottom: 5vh;
  width: 100%;
  height: 100%;
`;

const HeaderGrid = styled(Grid)`
  text-align: center;
`;

const FamilyIcon = styled.img`
  margin: 20px 0;
  max-width: 72px;
  width: 100%;
`;

export class Pricing extends React.PureComponent {
  componentWillMount() {
    this.props.setTopNavColorDark();
  }

  componentDidMount() {
    this.props.getProductPricingStack(this.props.match.url);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.match.url !== this.props.match.url) {
      this.props.getProductPricingStack(this.props.match.url);
    }
  }

  render() {
    const { stack } = this.props;

    return (
      <Fragment>
        <MetaTags stack={stack} />
        <Wrapper>
          <Container>
            <HeaderGrid container alignItems="flex-start">
              <Grid item xs={12}>
                <FamilyIcon src={stack.icon.url} alt="" />
              </Grid>

              <Grid item xs>
                <PageHeaderText
                  heading={stack.title}
                  subheading={stack.description}
                />
                <PaddedDivider hide />
              </Grid>
            </HeaderGrid>
          </Container>
          <Container>
            <div>
              {(stack.products || []).map((product, idx) => (
                <WideProductCard
                  key={idx}
                  name={product.product_reference?.[0]?.name}
                  iconurl={product.product_reference?.[0]?.icon?.url}
                  shortDescription={product.description}
                  cta={product.product_reference?.[0].order_url}
                  moreLink={product.product_reference?.[0].page_url}
                  listPrice={product.price}
                  shippingSpeed={product.shipping_time}
                />
              ))}
            </div>
            <PaddedDivider />

            {stack.cta.length > 0 && (
              <CallsToAction actionItems={stack.cta} theme={lightTheme} />
            )}

            {stack.quote.length > 0 && (
              <Fragment>
                <PaddedDivider />
                {stack.quote.map((quote, idx) => (
                  <Quote quote={quote} key={idx} />
                ))}
              </Fragment>
            )}

            {(stack.resource_reference.length > 0 ||
              stack.blog_reference.length > 0) && (
              <Fragment>
                <PaddedDivider />
                <RelatedContent
                  resource={stack.resource_reference}
                  blog={stack.blog_reference}
                />
              </Fragment>
            )}
          </Container>
        </Wrapper>

        <ExtendedFooter
          content_id={
            stack?.products?.[0]?.product_reference?.family?.toString() ===
            'blt4d1d60882c19f9b6'
              ? 'bltdc94bfb45d36a9d0'
              : 'bltd660bc4586edddad'
          }
          theme={darkTheme}
        />
      </Fragment>
    );
  }
}

Pricing.propTypes = {
  stack: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    product: PropTypes.array.isRequired,
    cta: PropTypes.array.isRequired,
    resource_reference: PropTypes.array,
    blog_reference: PropTypes.array
  })
};

export default connect(
  state => ({
    stack: state.productPricing.stack
  }),
  {
    getProductPricingStack,
    setTopNavColorDark
  }
)(Pricing);
